import rohmLogo from "@/assets/rohm-logo.png";

const TENANT_LOGOS = {
  rohm: rohmLogo,
};

export function getTenantLogo(clientId) {
  return TENANT_LOGOS[clientId] || null;
}
